<script setup lang="ts">
import { useToastStore } from "@/shared/lib"

import Toast from "./Toast.vue"

/**
 * Teleport-регіон toast-стека (ADR-0010 D6). Підписаний на `useToastStore`
 * (`shared/lib`), монтується РАЗ у `AppLayout`. `aria-live="polite"` —
 * нотіси читаються неблокуюче. Анімація — DS-стандарт (`TransitionGroup`),
 * без нових залежностей. ui→lib у межах `shared` (легально, spec §3.3).
 */
const props = withDefaults(
  defineProps<{
    label?: string
  }>(),
  { label: "Сповіщення" },
)

const store = useToastStore()
</script>

<template>
  <Teleport to="body">
    <div
      data-testid="toast-host"
      role="region"
      aria-live="polite"
      :aria-label="props.label"
      class="pointer-events-none fixed right-4 top-[4.5rem] z-[100] flex flex-col items-end gap-2"
    >
      <TransitionGroup
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="-translate-y-2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="absolute transition duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="-translate-y-1 opacity-0"
      >
        <Toast
          v-for="item in store.items"
          :key="item.id"
          class="pointer-events-auto"
          :variant="item.variant"
          :title="item.title"
          :description="item.description"
          @dismiss="store.dismiss(item.id)"
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>
